import { requestState, responseState } from "../utils";
import { SeasonPriceAction, SeasonPriceActionEnum, SeasonPriceState } from "./types";

const initialState: SeasonPriceState = {
    seasonPriceList: [],
    isLoading: {
        all: false,
        get: false,
        add: false,
        delete: false,
        update: false,
    },
    result: {},
};
const seasonPrice = (state = initialState, action: SeasonPriceAction): SeasonPriceState => {
  switch (action.type) {
    case SeasonPriceActionEnum.REQUEST_SEASONPRICE:
      return { ...state, isLoading: { ...state.isLoading, all: true } };
    case SeasonPriceActionEnum.RESULT_SEASONPRICE:
      return {
        ...state,
        seasonPriceList: action.data,
        isLoading: { ...state.isLoading, all: !action.data },
      };
    case SeasonPriceActionEnum.REQUEST_ADD_SEASONPRICE:
    return requestState(state, "add");

    case SeasonPriceActionEnum.RESULT_ADD_SEASONPRICE:
      return responseState(state, "add", action);

    case SeasonPriceActionEnum.REQUEST_UPDATE_SEASONPRICE:
      return requestState(state, "update");

    case SeasonPriceActionEnum.RESULT_UPDATE_SEASONPRICE:
      return responseState(state, "update", action);
  
    case SeasonPriceActionEnum.REQUEST_DELETE_SEASONPRICE:
      return requestState(state, "delete");

    case SeasonPriceActionEnum.RESULT_DELETE_SEASONPRICE:
      return responseState(state, "delete", action);

    case SeasonPriceActionEnum.CLEAR_SEASONPRICE_RESULT:
      return { ...state, result: {} };

    default:
      return state;
  }
};
export default seasonPrice;
